<template>
  <transition name="el-loading-fade">
    <div
      v-show="visible"
      class="loading-mask"
    >
      <div class="el-loading-spinner">
         <img  v-if="loadImg" :src="loadImg" >
        <p v-if="loadText" class="loading-text">{{ loadText }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props:{
    visible:{},
    loadImg:{},
    loadText:{
      default(){
        return ''
      }
    },
    },
    data() {
      return {
      };
    },
    methods: {
    }
  };
</script>
<style lang="scss" scoped>
.loading-mask{
position: absolute;
    z-index: 2000;
    background-color: rgba(255,255,255,.9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
.loading-text{
    font-size: 12px;
    color: #888A92;
    margin-top: 10px;
}
</style>
